// User API
import {
    RequestConfigFunction, SelectorConfig,
} from 'app/types/request.types'
import {
    User,
} from '../Apps/ContactManagement/Users/Users.types'

type UserRequests = {
    domainName: string,
    get: RequestConfigFunction<{id: number}>,
    create: RequestConfigFunction<undefined>,
    update: RequestConfigFunction<{id: string}>,
    getUsers: RequestConfigFunction<Record<string, any>>,
}

const userRequests: UserRequests = {
    domainName: 'User',
    get: ({
        id,
    }) => {
        return {
            url: `user/${id}`,
            method: 'GET',
        }
    },
    create: () => {
        return {
            url: 'user',
            method: 'POST',
        }
    },
    update: ({
        id,
    }) => {
        return {
            url: `user/${id}`,
            method: 'PUT',
        }
    },
    getUsers: (params) => {
        return {
            url: 'user/filter-request/all',
            method: 'POST',
            data: {
                ...params,
            },
        }
    },
}

export const userSelectionConfig: SelectorConfig<User[]> = {
    url: userRequests.getUsers().url,
    convertion: (users) => {
        return users.map(({
            id,
            userName,
        }) => {
            return {
                label: userName,
                value: id,
                id,
            }
        })
    },
}

export default userRequests
